import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminComponent} from './admin.component';
import {AdminFooterComponent} from './admin-footer/admin-footer.component';
import {HtmlPageComponent} from './html-page/html-page.component';
import {AdminRoutingModule} from './admin-routing.module';
import {BosCommonsModule} from 'bos-commons';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {SharedModule} from '../shared/shared.module';
import {MaterialModule} from '../shared/material/material.module';
import {PreventDoubleSubmitModule} from 'ngx-prevent-double-submission';
import { LoggedUsersComponent } from './logged-users/logged-users.component';
import { AdminLinksComponent } from './admin-links/admin-links.component';
import {HtmlAnchorComponent} from './html-anchor/html-anchor.component';
import { AdminSessionConfigComponent } from './admin-session-config/admin-session-config.component';
import { AdminLevenshteinConfigComponent } from './admin-levenshtein-config/admin-levenshtein-config.component';


@NgModule({
    declarations: [
        AdminComponent,
        AdminFooterComponent,
        AdminLinksComponent,
        HtmlPageComponent,
        LoggedUsersComponent,
        HtmlAnchorComponent,
        AdminSessionConfigComponent,
        AdminLevenshteinConfigComponent
    ],
    imports: [
        CommonModule,
        BosCommonsModule,
        AdminRoutingModule,
        AngularEditorModule,
        MaterialModule,
        SharedModule,
        PreventDoubleSubmitModule
    ]
})
export class AdminModule {
}
